import React, { useMemo } from "react";
import { ApiAction } from "./types";

export interface IApiContext {
  authToken: string;
  call: <T extends ApiAction>(action: T['action'], payload: T['Req']) => Promise<T['Resp']>;
}

export const ApiContext = React.createContext<IApiContext>({authToken: '', call: () => new Promise(() => {}) })

export const ApiContextProvider: React.FC<React.PropsWithChildren<{prefix: string, authToken: IApiContext['authToken']}>> = ({ authToken, children, prefix }) => {
  const val: IApiContext = useMemo(() => {
    async function call<T extends ApiAction>(action: T['action'], payload: T['Req']): Promise<T['Resp']> {
      const response = await fetch(`${prefix}${action}`, {
        method: 'POST',
        body: JSON.stringify({authenticity_token: authToken, ...payload}),
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();
      return data as T;
    };
    return {
      authToken,
      call
    };
  }, [authToken]);

  return <ApiContext.Provider value={val}>{children}</ApiContext.Provider>
}
